import React from 'react';
import BaseClass from '@/pages/BaseClass';

import $ from 'jquery';
import {
} from 'antd'
import {
	CommonValue,
	ngUrl,
	pcUrl,
	confirm,
	message,
	notify,
	httpPost
} from '@/utils/Tools';

export default class App extends BaseClass
{
	constructor(props)
	{
		super(props);
		
		this.state={
			'userRights':{},
		};
	}
	
	componentDidMount()
	{
		this.getUserRights();
		document.title = '会员权益 - ' + CommonValue.get('site_name');
	}
	
	getUserRights()
	{
		let url = pcUrl('user','rights');
		httpPost(url)
			.then(data=>{
				this.setState({
					'userRights':data,
				});
			});
	}
	
	render()
	{
		return (
			<div className="user-rights">
				<img src={this.state.userRights.content} />
			</div>
		);
	}
}

